<template>
	<div>
		<template v-if="showTimeline">
			<Timeline />
		</template>
		<template v-else>
			<Default />
		</template>
	</div>
</template>

<script>
import Default from "src/components/Dashboards/Default";
import Timeline from "src/components/Dashboards/Timeline";

export default {
	components: {
		Default,
		Timeline
	},
	computed: {
		isStudent: function() {
			if(!this.$UserSession.hasPriv.call(this, "ALL")){
				return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
			}
			return false;
		},
		showTimeline: function() {
			if(this.$config.hasModule('timeline')){
				return this.isStudent;
			}
			return false;
		}
	}
};
</script>
